import { JsonProperty, ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class RecruitRejectionReasonModel
  extends Model
  implements IModel<RecruitRejectionReasonModel>
{
  @JsonProperty()
  public id: string = '';

  @JsonProperty()
  public companyGroupId: string | null = null;

  @JsonProperty()
  public title: string = '';

  @JsonProperty()
  public description: string = '';

  @JsonProperty()
  public type: number = 1;

  @JsonProperty()
  public enable: boolean = true;

  static create(input: any): RecruitRejectionReasonModel {
    return ObjectMapper.deserialize<RecruitRejectionReasonModel>(RecruitRejectionReasonModel, input);
  }
}
